"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DocPpt_exports = {};
__export(DocPpt_exports, {
  default: () => DocPpt_default
});
module.exports = __toCommonJS(DocPpt_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00002 5.0999C7.22683 5.0999 6.60002 5.7267 6.60002 6.4999V9.4999C6.60002 9.83127 6.3314 10.0999 6.00002 10.0999C5.66865 10.0999 5.40002 9.83127 5.40002 9.4999V6.4999C5.40002 5.06396 6.56408 3.8999 8.00002 3.8999H14.6134C15.0114 3.8999 15.3952 4.04826 15.6897 4.316L18.0763 6.48564C18.4099 6.78888 18.6 7.21875 18.6 7.66955V9.4999C18.6 9.83127 18.3314 10.0999 18 10.0999C17.6687 10.0999 17.4 9.83127 17.4 9.4999V8.75H15C14.1716 8.75 13.5 8.07843 13.5 7.25V5.0999H8.00002ZM14.5 5.0999V7.25C14.5 7.52614 14.7239 7.75 15 7.75H17.4V7.66955C17.4 7.55685 17.3525 7.44938 17.2691 7.37357L14.8825 5.20393C14.8089 5.13699 14.7129 5.0999 14.6134 5.0999H14.5ZM5.07341 15.3682H3.76541V12.9322H5.07341C5.90141 12.9322 6.40541 13.4002 6.40541 14.1562C6.40541 14.8882 5.90141 15.3682 5.07341 15.3682ZM3.75341 16.7962H5.27741C6.95741 16.7962 8.07341 15.6922 8.07341 14.1442C8.07341 12.6082 6.95741 11.4922 5.27741 11.4922H2.09741V20.0002H3.75341V16.7962ZM11.8156 15.3682H10.5076V12.9322H11.8156C12.6436 12.9322 13.1476 13.4002 13.1476 14.1562C13.1476 14.8882 12.6436 15.3682 11.8156 15.3682ZM10.4956 16.7962H12.0196C13.6996 16.7962 14.8156 15.6922 14.8156 14.1442C14.8156 12.6082 13.6996 11.4922 12.0196 11.4922H8.8396V20.0002H10.4956V16.7962ZM21.8809 13.0642H19.1929V20.0002H17.5249V13.0642H14.8369V11.4922H21.8809V13.0642Z",
      fill: "currentColor"
    }
  )
);
const SvgDocPpt = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DocPpt_default = SvgDocPpt;
